import React from 'react';
import {Button} from '@tickchak/react-share/app';
import BoldIcon from '../../../../../assets/icons/BoldIcon';
import ItalicIcon from '../../../../../assets/icons/ItalicIcon';
import {WHATSAPP_MAX_TEXT_LENGTH} from '../../../../../pages/branding/whatsAppScreen/whatsAppValidation';
import * as css from './WhatsAppEditorFooterToolbar.css';

interface WhatsAppEditorFooterToolbarProps {
    onFormat?: (command: string) => void;
    totalCharacters: number;
    isCharCountExceeded: boolean;
    onClearAll: () => void;
    clearAllLabel: string;
}

function WhatsAppEditorFooterToolbar({
    onFormat,
    totalCharacters,
    isCharCountExceeded,
    onClearAll,
    clearAllLabel,
}: WhatsAppEditorFooterToolbarProps) {
    return (
        <css.toolbarRow>
            {onFormat && (
                <css.toolbarStart>
                    <css.formatButton
                        type="button"
                        onClick={() => onFormat('italic')}
                        title="Italic"
                        data-cy="whatsapp-editor-italic-btn"
                    >
                        <ItalicIcon />
                    </css.formatButton>
                    <css.formatButton
                        type="button"
                        onClick={() => onFormat('bold')}
                        title="Bold"
                        data-cy="whatsapp-editor-bold-btn"
                    >
                        <BoldIcon />
                    </css.formatButton>
                </css.toolbarStart>
            )}
            <css.toolbarEnd>
                <css.charCounter isExceeded={isCharCountExceeded} data-cy="whatsapp-editor-char-counter">
                    {totalCharacters}/{WHATSAPP_MAX_TEXT_LENGTH}
                </css.charCounter>
                <Button
                    variant="neutral"
                    size="chip"
                    onClick={onClearAll}
                    title={clearAllLabel}
                    data-cy="whatsapp-editor-clear-all-btn"
                >
                    {clearAllLabel}
                </Button>
            </css.toolbarEnd>
        </css.toolbarRow>
    );
}

export default WhatsAppEditorFooterToolbar;
